import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, Navigate, Outlet } from "react-router-dom";
import { motion } from "framer-motion";

import Remove from "../../components/Cart/Remove";
import classes from "./Inquire.module.css";
import { ButtonPrimary } from "../../components/Button/Button";
import { useEffect, useState } from "react";

const Inquire = () => {
  const navigate = useNavigate();
  const cartData = useSelector((state) => state.cart.items);
  const [hasItems, setHasItems] = useState(false);

  useEffect(() => {
    if (cartData.length > 0) {
      setHasItems(true);
    } else {
      setHasItems(false);
    }
  }, [cartData]);

  const nextStepHandler = () => {
    navigate("fewMoreQuestions");
  };

  const backToProductPage = () => {
    navigate("/product");
  };

  const cartList = cartData.map((item) => {
    return (
      <li className={classes.cart__list} key={item.id}>
        <img
          src={item.img}
          alt="TBD"
          onClick={() => {
            navigate(`/product/${item.id}`);
          }}
        />

        <div className={classes.cart__item}>
          <span
            className={classes.itemName}
            onClick={() => {
              navigate(`/product/${item.id}`);
            }}
          >
            {item.itemName}
          </span>

          <Remove
            id={item.id}
            className={classes.remove}
            setHasItems={setHasItems}
          />
        </div>
      </li>
    );
  });

  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0, transition: { duration: "0.1" } }}
        className={classes.inquire}
      >
        <h2 className={classes.title}>已選取的商品</h2>
        {!hasItems && (
          <span className={classes.hasNoItems}>你還沒有選擇任何商品喔✌️</span>
        )}
        {!hasItems && (
          <span
            className={classes.backToProductPage}
            onClick={backToProductPage}
          >
            返回商品頁面
          </span>
        )}
        <ul className={classes.cart}>{cartList}</ul>
        {hasItems && (
          <ButtonPrimary
            className={classes.button}
            text="下一步"
            onClick={nextStepHandler}
          />
        )}
      </motion.div>
    </>
  );
};

export default Inquire;
